/*******************************************************************************
 * Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>
 *
 * This file MixinCheckout.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * MixinCheckout.js can not be copied and/or distributed
 * without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
 ******************************************************************************/

export const checkout = {
    data() {
        return {
            show_pay_button: false,
            checkout_active: false,
            card_error_vue: null,

            /**
             * @function  stripe.data.createPaymentMethod,<type,card>
             * @param stripe.data
             * @param stripe
             */
            stripe: {
                // token_id: null, // not used in new api
                payment_method_id: null,
                payment_intent_id: null,
                progress: 0,
                data: null,
                elements: null,
                card: undefined,
                style: {
                    base: {
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        // padding: '2rem',
                        // border: '1px solid #D8D8D8',
                        // borderRadius: '4px',
                        color: "#F5F5F5",
                        '::placeholder': {
                            color: '#CFD7E0',
                            fontWeight: 200
                        },
                    },
                    empty: {
                        color: "#F5F5F5",
                    },
                    invalid: {
                        color: "red",
                    },
                }
            },
        }
    },
    methods: {
        test() {
            console.log('test')
        },
        /**
         * @link https://stripe.com/docs/payments/payment-intents/migration#elements-step-3
         * @param response.data.payment_method_id
         * @param response.data.payment_intent_client_secret
         * @param {Object} response.data
         * @param {Object} response
         * @param {Boolean} create_payment_intent
         */
        handleCardActionResponse(response, create_payment_intent) {
            let self = this;
            return new Promise(function (resolve, reject) {

                self.setProgress(true);

                let clientSecret = response.data.payment_intent_client_secret;

                if (create_payment_intent === true) {
                    self.stripe.payment_method_id = response.data.payment_method_id;
                    try {
                        self.stripe.data
                            .handleCardPayment(
                                clientSecret,
                                {
                                    payment_method: self.stripe.payment_method_id
                                }
                            )
                            .then(function (result) {
                                resolve(result);
                            });

                    } catch (e) {
                        console.error(e);
                        console.error(e.message);
                    }
                } else {

                    self.stripe.data
                        .handleCardAction(
                            clientSecret
                        )
                        .then(function (result) {
                            resolve(result)
                        });
                }

            });

        },
        /**
         * @param result.paymentIntent
         * @param result.error
         * @param result
         */
        processStripeCardAction(result) {
            let self = this;
            return new Promise(function(resolve,reject){
                if (result.error) {
                    // console.error(result.error);
                    // Show error in payment form
                    self.setError(result.error);
                    reject(result.error);
                } else {
                    self.stripe.payment_intent_id = result.paymentIntent.id;
                    self.setProgress(true);
                    // The card action has been handled
                    // The PaymentIntent can be confirmed again on the server
                    self.$nextTick(function () {
                        // self.makeRequest(self.setProgress(true), url, self.$refs.form.getElementsByTagName('input'));
                        resolve(result);
                    });
                }
            })
        },
        setError(error) {
            let self = this;

            let errorData = JSON.parse(JSON.stringify(error));
            if (errorData.response) {
                // catch error if any
                self.card_error_vue = errorData.response.data.message;
            } else {
                // catch error if any
                self.card_error_vue = errorData.message;
            }
        },
        initPaymentStatus() {
            let self = this;

            self.card_error_vue = null;
            self.checkout_active = true;
            self.stripe.progress = 10;
        },
        /**
         *
         * @param {String} reference
         * @param card
         * @param stripe
         */
        initStripe(reference, card, stripe) {
            let self = this;

            self.stripe.data = stripe;
            if (reference !== 'saved_card') {
                // Set up Stripe Elements
                self.stripe.elements = self.stripe.data.elements();
                // console.log('self.stripe.elements', self.stripe.elements);
                // Create an instance of the card Element.
                self.stripe.card = self.stripe.elements.create('card', {
                    style: self.stripe.style,
                    hidePostalCode: true,
                    iconStyle: 'solid'
                });
                // console.log(reference, self.$refs);
                // Add an instance of the card Element into the `card-element` <div>.
                self.stripe.card.mount(card);

                self.stripe.card.addEventListener('change', function (event) {
                    if (event.complete) {
                        self.show_pay_button = true
                    } else {
                        self.show_pay_button = self.checkout_active = false
                    }
                });
            }
        },
        /**
         * set progress bar up or down
         * */
        setProgress(up) {
            let self = this;

            if (up) {
                if (self.stripe.progress + 10 > 100) {
                    self.stripe.progress = 100;
                } else {
                    self.stripe.progress = self.stripe.progress + 10;
                }
            } else {

                if (self.stripe.progress - 10 < 0) {
                    self.stripe.progress = 0;
                } else {
                    self.stripe.progress = self.stripe.progress - 10;
                }
            }
        },
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/MixinCheckout.js